export const getJson = <T>(key: string): T | null => {
  const raw = localStorage.getItem(key)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw) as T
  } catch {
    // A corrupt entry must never break app startup — drop it.
    localStorage.removeItem(key)
    return null
  }
}

export const setJson = (key: string, value: unknown): void => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const remove = (key: string): void => {
  localStorage.removeItem(key)
}
